export default {
  insuranceID: {
    value: null,
    options: [{text: 'Tokio Marine', value: '469598e8-33fa-46f5-a439-ad406b471bf0'}],
    clearOption: true,
    required: true,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: true,
    rows: 7,
    cols: 200,
    noResize: true,
    state: null
  },
  schedulingTypeID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null
  },
  businessTypeID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  budgetSystemID: {
    value: null,
    options: [],
    clearOption: false,
    required: false,
    state: null
  },
  responsibleID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  import: {
    value: '0',
    options: [],
    required: false,
    state: null
  },
  save: {
    value: '0',
    options: [],
    required: false,
    state: null
  },
  error: {
    value: '0',
    options: [],
    required: false,
    state: null
  },
  actionDate: {
    value: '0',
    options: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/imports/importregulationauto-form.js